import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import BarChart from "../Charts/BarChart";
import { Link } from "react-router-dom";
import axios from "axios";
import { useState, useCallback, useEffect, useContext } from "react";
import { useAuth } from "../Context/AuthContext";
import { Loader } from "../Loader/Loader";
const styles = {
  MainDiv: {
    backgroundColor: "#f4f4f4",
    width: "100vw",
    height: "100vh",
  },

  card: {
    height: "260px",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "20px",
    paddingTop: "20px",
  },
  backButton: {
    background: "transparent",
    border: "none",
    fontWeight: "bold",
    color: "#000078",
    cursor: "pointer",
    alignItems: "center",
    boxShadow: "none",
  },
};

const DetailedCharts = () => {
  const { token } = useAuth();
  const [detailedChartData, setdetailedChartData] = useState([]);
  const URL = process.env.REACT_APP_URL;
  const [loading, setLoading] = useState(false);

  const fetchDetailedChartsData = useCallback(async () => {
     setLoading(true);
    let url = `${URL}get-detailed-chart-data`;
    try {
      const response = await axios.get(url,{
        headers: {
          Authorization: `abc ${token}`,
        },
      });

      setTimeout(() => {
        setdetailedChartData(response?.data?.data);
      setLoading(false);
    }, 2000);
      
      //toast.success("Other Consumption Data Updated");
    } catch (err) {
      console.error(err?.response?.data?.message);
    }
  }, []);

  useEffect(() => {
    fetchDetailedChartsData();
}, []);

  useEffect(() => {
    fetchDetailedChartsData();
  }, [fetchDetailedChartsData]);

  
  return (
    <div style={styles.MainDiv}>
      <Container fluid style={{ padding: "40px" }}>
        <Row>
          <Col
            sm={12}
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            style={{
              display: "flex",
              justifyContent: "start",
            }}
          >
            <Link to="/cxodashboard">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <Button style={styles.backButton}>
                  <img
                    className="img"
                    alt="Vector"
                    src={require("../Assets/arrowLeft.png")}
                    height={20}
                    width={20}
                  />
                </Button>

                <div
                  style={{
                    color: "#375EAD",
                    fontWeight: "600",
                    marginLeft: "20px",
                  }}
                >
                  Back to dashboard
                </div>
              </div>
            </Link>
          </Col>
              {loading && <Loader height={'60vh'} />      
              }
          {detailedChartData.length > 0 &&
            detailedChartData.map((data, index) => (
              <Col
                key={index}
                sm={12}
                xs={12}
                md={12}
                lg={6}
                xl={4}
                xxl={4}
                style={{ padding: "20px" }}
              >
                <div className="card" style={styles.card}>
                  <BarChart
                    data={{
                      labels: data?.map((item) => item.month),
                      datasets: [
                        {
                          label: "Neutrality",
                          data: data?.map((item) => item?.data),
                          barThickness: 15,
                          maxBarThickness: 15,
                          barPercentage: 1,
                          categoryPercentage: 1,
                        },
                      ],
                    }}
                    width={400}
                    height={240}
                    titleX={
                      index === 0
                        ? "NEUTRALITY (Last 4 months)"
                        : index === 1
                        ? "A1 : Rainwater Harvest"
                        : index === 2
                        ? "A2 : Rainwater Recharge"
                        : index === 3
                        ? "A3 : Pond Water Recharge"
                        : index === 4
                        ? "A4 : RO + Horticulture + PCMC Water"
                        : index === 5
                        ? "C  : MIDC"
                        : null
                    }
                    titleY={
                      index === 0
                        ? "NEUTRALITY (Last 4 months)"
                        : "Volume (KL * 10\u2075)"
                    }
                    color={
                      index === 0
                        ? "#71a6af"
                        : index === 1
                        ? "#617834"
                        : index === 2
                        ? "#ba7e54"
                        : index === 3
                        ? "#77b585"
                        : index === 4
                        ? "#9e65a3"
                        : index === 5
                        ? "#7a4d62"
                        : "#6992CC"
                    }
                  />
                </div>
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  );
};

export default DetailedCharts;
